import $ from 'jquery';
import {
  DataTableComponent,
  batchCheckControls,
} from 'web/components/CommonComponent';
import {useCallback, useState} from 'react';
import enumList from 'web/utils/enumList';
import {fetchMachineAssignments as fetchMachineAssignmentList} from 'web/redux/actions/RelCustomerMachineActions';

export const useMachineAssignment = (
  dispatch,
  showMessage,
  onBatchHandle,
  baseComponent
) => {
  const [machineAssignmentList, setMachineAssignmentList] = useState([]);

  const getMachineAssignmentList = useCallback(
    (
      customerName = '',
      deliveryCode = '',
      machineSerialNumber = '',
      machineTypeId = ''
    ) => {
      console.log(
        'getMachineAssignmentList:',
        customerName,
        deliveryCode,
        machineSerialNumber,
        machineTypeId
      );
      const req = {
        customerName,
        deliveryCode,
        machineSerialNumber,
        machineTypeId,
      };

      dispatch(fetchMachineAssignmentList(req))
        .then((res) => {
          const statusCode = res.payload.code;
          if (statusCode && statusCode.isSuccessCode()) {
            setMachineAssignmentList(res.payload.result);
            const assignmentListRes = res.payload.result;
            prepareMachineAssignmentTable(assignmentListRes);
          } else {
            // showMessage('error', '', res);
          }
        })
        .catch((err) => {
          showMessage('error', err);
          console.error('fetchMachineAssignmentList error', err);
        });
    },
    [dispatch, showMessage, baseComponent, onBatchHandle]
  );

  const prepareMachineAssignmentTable = (assignmentList) => {
    const dataSet = assignmentList.map((item) => {
      return [
        item.recordYear,
        item.deliveryCode,
        item.machineModel,
        item.machineSerialNumber,
        item.machineTypeName,
        item.memo,
      ];
    });

    const columnConfig = [
      {
        orderable: false,
        order: null,
        title:
          '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
        data: null,
        render: function (data, type, row, meta) {
          const checkboxId = 'cks-assignment-' + meta.row;
          return `
                <div class="form-check">
                    <input class="form-check-input item-cks-assignment" type="checkbox" value="" id="${checkboxId}" name="cks" />
                    <label class="form-check-label" for="${checkboxId}"></label>
                </div>
            `;
        },
        width: '5%',
      },
      {title: '年份', className: 'dt-center', data: 0},
      {title: '交機編號', className: 'dt-center', data: 1, defaultContent: ''},
      {title: '機械型式', className: 'dt-center', data: 2, defaultContent: ''},
      {title: '機械番號', className: 'dt-center', data: 3, defaultContent: ''},
      {title: '機種', className: 'dt-center', data: 4, defaultContent: ''},
      {title: '備註', className: 'dt-center', data: 5, defaultContent: ''},
      {
        orderable: false,
        order: null,
        data: null,
        className: 'dt-right',
        render: (data, type, row, meta) => {
          const editId = 'edit-assignment-' + meta.row;
          const updateButton = baseComponent.checkPermission(
            enumList.moduleEnums.customer,
            enumList.accessModeEnums.update
          )
            ? `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                    <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`
            : '';
          return `
                <div class="btn-group" role="group" aria-label="">
                    ${updateButton}
                </div>`;
        },
      },
    ];

    const orderConfig = {idx: 1, dir: 'asc'};
    const fixedColumnsConfig = {start: 1};

    if ($.fn.DataTable.isDataTable('#datatable__machineAssignmentList')) {
      $('#datatable__machineAssignmentList').DataTable().destroy();
    }

    DataTableComponent(
      '#datatable__machineAssignmentList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true
    );
    batchCheckControls();
  };

  const onBatch = (alertMode = enumList.alertModalModeEnums.enable) => {
    const customerCodes = [];
    const checkboxes = document.querySelectorAll('.item-cks-assignment');
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const customerCode =
          machineAssignmentList[parseInt(checkbox.id.split('-')[2])]
            .customerCode;
        customerCodes.push(customerCode);
      }
    });
    if (customerCodes.length === 0) {
      return;
    }
    onBatchHandle(alertMode, '', customerCodes);
  };

  return {machineAssignmentList, getMachineAssignmentList, onBatch};
};
